import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import CategoriesNav from "../components/CategoriesNav";
import MainTitle from "../components/MainTitle";
import AuthService from "../services/auth.service";

const Home = () => {
  const [posts, setPosts] = useState([]);
  const [privatePosts, setPrivatePosts] = useState([]);
  useEffect(() => {
    const fetch = async () => {
      console.log("fetching data");
      try {
        let { data } = await axios.get(process.env.REACT_APP_API_BASE_URL+"/wp/v2/posts?_embed=1");
        console.log(data);
        setPosts(data);        
      } catch (err) {
        console.error(err);
      }
    };

    const fetchPrivateData = async () => {
      console.log("fetching private data");
      try {
        const currentUser =  AuthService.getCurrentUser();
        // https://flaviocopes.com/axios-send-authorization-header/
        if (currentUser) {
          const authHeaderToken = `Bearer ${currentUser.token}`;
          console.log(authHeaderToken);
          let { data } = await axios.get(process.env.REACT_APP_API_BASE_URL+"/wp/v2/posts?status=private&_embed=1", {
            headers: {
              'Authorization': authHeaderToken
            }
          });
          console.log(data);
          setPrivatePosts(data); 
        }
      } catch (err) {
        console.error(err);
      }    
    };
    
    fetchPrivateData();
    fetch();
    
  }, []);
  return (
    <div>
      <MainTitle />
      <CategoriesNav />
      <div className="articleList">
      {privatePosts?.map((el) => (
        <article key={el.id} className="shadow p-3 mb-5 bg-body rounded private">
          <div className="metas mb-3">
            <LastPublicationDate pubdate={new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "2-digit"
            }).format(Date.parse(el.date_gmt))} />
          </div>
          <Link to={`/post/${el.id}`}>
            <h2>
              {el.title.rendered}
            </h2>
          </Link>
          <p>{el.excerpt.rendered.replace(/<[^>]+>/g, '')}</p>
          <div className="categories">
              <CategoryLabel name="Premium content" key="subscribers" />
              {el._embedded["wp:term"][0] && el._embedded["wp:term"][0].map((cat) => (
                //cat.name+" "
                <CategoryLabel name={cat.name} key={cat.id} />
                )
              )}            
          </div>
        </article>
      ))}
      {posts?.map((el) => (
        <article key={el.id} className="shadow p-3 mb-5 bg-body rounded">
          <div className="metas mb-3">
            <LastPublicationDate pubdate={new Intl.DateTimeFormat("en-US", {
              year: "numeric",
              month: "long",
              day: "2-digit"
            }).format(Date.parse(el.date_gmt))} />
          </div>
          <Link to={`/post/${el.id}`}>
            <h2>
              {el.title.rendered}
            </h2>
          </Link>
          <p>{el.excerpt.rendered.replace(/<[^>]+>/g, '')}</p>
          <div className="categories">
              {el._embedded["wp:term"][0] && el._embedded["wp:term"][0].map((cat) => (
                //cat.name+" "
                <CategoryLabel name={cat.name} key={cat.id} />
                )
              )}            
          </div>
        </article>
      ))}
    </div>
      </div>
      
  );
};


const CategoryLabel = (props) => {
  const compStyle = {
    marginRight: '0.4rem'
  }
  return(
    <span className="badge bg-secondary" style={compStyle}>{props.name}</span>
  );
}

const LastPublicationDate = (props) => {
  const compStyle = {
    marginRight: '0.4rem'
  }
  return(
    <span className="badge bg-warning text-dark" style={compStyle}>{props.pubdate}</span>
  );
}


export default Home;